import { Route, Switch } from 'react-router';
import {BrowserRouter as Router, } from 'react-router-dom'
import FirstLogin from '../Pages/FirstLogin/FirstLogin';
import FirstLoginCreateAccount from '../Pages/FirstLoginCreateAccount/FirstLoginCreateAccount';
import Deconnection from '../Pages/Deconnection/Deconnection';

export const AUTH_ROUTES = [
  {
    name: 'firstLogin',
    route: '/FirstLogin',
    component: FirstLogin
  },
  {
    name: 'firstLoginToken',
    route: '/FirstLogin/:token',
    component: FirstLoginCreateAccount
  },
  {
    name: 'deconnection',
    route: '/Deconnection',
    component: Deconnection
  }
];

const AuthRoutes = () => (
  <Router>
    <Switch>
      <Route
        exact
        path="/redirect/to"
        component={(props) => {
          const redirectTo = (url) => (window.location.href = url);
          const params = new URLSearchParams(props.location.search);
          const webUrl = params.get('url');
          const mobileUrl = params.get('url_mobile');

          redirectTo(mobileUrl);

          const now = Date.now();
          setTimeout(() => {
            if (Date.now() - now < 400) {
              redirectTo(webUrl);
            }
          }, 200);
          return <div>redirect</div>;
        }}
      />

      {AUTH_ROUTES?.map(({ component, route, name }) => (
        <Route key={name} exact path={route} component={component} />
      ))}
    </Switch>
  </Router>
);

export default AuthRoutes;
